import { render, staticRenderFns } from "./faceBook.vue?vue&type=template&id=417f1cdf&scoped=true"
import script from "./faceBook.vue?vue&type=script&lang=js"
export * from "./faceBook.vue?vue&type=script&lang=js"
import style0 from "./faceBook.vue?vue&type=style&index=0&id=417f1cdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417f1cdf",
  null
  
)

export default component.exports